import React, { useContext, useEffect, useMemo, useRef, useState } from "react";
import "./dashboard.css";
import { TabMenuType, TabmenuItem } from "../../components/tabmenu/Tabmenu";

import axios from 'axios';

import { useSearchParams, useLocation, useNavigate } from "react-router-dom";

import { convertTimeString, getCurrentDate } from "../../utils/TimeUtils";

import refreshIcon from "../../assets/RefreshIcon.svg";
import filterIcon from "../../assets/FilterIcon.svg";
import fullscreenIcon from "../../assets/FullscreenIcon.svg";

import { SearchIcon } from "../../assets/SearchIcon";
import { ClearIcon } from "../../assets/ClearIcon";

import InputfieldWithPlaceholder, { InputfieldType } from "../../components/inputfieldwithplaceholder/Inputfieldwithplaceholder";


import MasterButton, { ButtonLayoutType, ButtonSize, ButtonVariation } from "../../components/button/MasterButton";

import ParticipantState from "../../components/participantstate/ParticipantState";
import DashboardSelectStudiesModal from "./dashboardSelectStudiesModal/dashboardSelectStudiesModal";

import studyDataExamples from '../../context/mock/StudyData.json';

import ModalOverlay from "../../components/modal/ModalOverlay";


import { useSelector , useDispatch } from 'react-redux';
import { AppDispatch, RootState } from '../../context/store';

import { fetchtempRangeAnomalyDataDetails, reloadtempRangeAnomalyDataDetails } from '../../context/content/dashboardPage/tempRangeAnomalyDataSlice';

import Skeleton from "../../components/skeleton/Skeleton";

import Plotly from 'plotly.js-basic-dist';
import Plot from 'react-plotly.js';
import PlotlyEvent from "react-plotly.js"
import PlotlyData from "react-plotly.js";

import ButtonGroup from "../../components/buttonGroup/buttonGroup";

import CustomTimeSelectionButtonBar from "../../components/customTimeSelectionButtonBar/customTimeSelectionButtonBar";

import { updateStudyInfo } from '../../context/studyInfoSlice';

import { useSharedState } from '../../context/sharedState';

import DashboardParticipantHoverModal from './dashboardParticipantHoverModal/dashboardParticipantHoverModal';
import DashboardParticipantInnerDetail from './dashboardParticipantInnerDetail/dashboardParticipantInnerDetail';
import DashboardParticipantDetailsModal from './dashboardParticipantDetailsModal/dashboardParticipantDetailsModal';

import { DateRange } from "react-day-picker";

import moment from "moment-timezone";

const BASE_URL = process.env.REACT_APP_API_BASE_URL;
const VERSION = process.env.REACT_APP_API_VERSION;

type Trace = PlotlyData;

type ParticipantStudyAnalytics = {
  homeostasisData: number; // range: 70 - 90
  activityData: number; // range: 0 - 5
  hotData: number; // range: 0 - 5
  offWristData: number; // range: 0 - 5
  coldData: number; // range: 0 - 5
  noData: number; // Always 0
}

interface PlotData {
  chart_data: string; // assuming chart_data is a JSON string
  cnt_indeterminate: number;
  cnt_pos: number;
  participant_name: string;
  last_updated_date: string;
  euid: string;
}

type ParticipantStudyDetails = {
  isPinned: boolean;
  hasAnomaly: boolean;
  anomalyPercentage: number; // range: 0 to 10
  hasError: boolean;
  participantID: string; // Example: 'LAS001NNN'
  dailyData: ParticipantStudyAnalytics;
  weeklyData: ParticipantStudyAnalytics;
  lastUpdate: string;
};

type studyData = ParticipantStudyDetails[];

let AnomalyDataStore : ParticipantStudyDetails[] = [];

type ParticipantModalDetails = {
  participant_name: string;
  participant_euid: string;
};

type StudyInfo = {
  StudyOrg: string;
  StudyName: string;
};

const formatDateRange = (date: Date | undefined): string => {

  if (!date) {
    return '';
  }

  return new Intl.DateTimeFormat('en-US', {
      month: '2-digit',
      day: '2-digit',
      year: 'numeric',
      hour: '2-digit',
      minute: '2-digit',
      hour12: true,
  }).format(date);
};

const getUTCOffset = (timezone: string | undefined): string => {
  
  if (!timezone || timezone === 'UTC') {
    return 'UTC';
  }

  const offsetMinutes = moment.tz(timezone).utcOffset(); // Get offset in minutes
  const sign = offsetMinutes >= 0 ? '+' : '-'; // Determine the sign
  const hours = Math.floor(Math.abs(offsetMinutes) / 60).toString().padStart(2, '0'); // Extract hours
  const minutes = (Math.abs(offsetMinutes) % 60).toString().padStart(2, '0'); // Extract minutes
  return `UTC${sign}${hours}:${minutes}`;
};

const Dashboard = () => {

  const [refreshDate, setRefreshDate] = useState(getCurrentDate());

  const [searchQuery, setSearchQuery] = useState("");
  const [searchActive, setSearchActive] = useState(false);

  const [placeholderValue, setplaceholderValue] = useState("");
  
  const search = (query: string) => {
    console.log("Search Query:", query);
    setSearchQuery(query);
  };

  const chartAreaRef = useRef<HTMLDivElement>(null);
  const [selectedParticipant, setSelectedParticipant] = useState<number>();
  const [isModalVisible, setModalVisible] = useState(false);

  // Participant Detail Modal States
  const [isParticipantDetailModalVisible, setIsParticipantDetailModalVisible] = useState<boolean>(false);
  const [currentParticipantInFocus, setCurrentParticipantInFocus] = useState<ParticipantModalDetails>({'participant_name' : "", 'participant_euid': ""});

  const [isLoading, setLoading] = useState(true);
  const [isRefreshing, setRefereshing] = useState(false);


  // Initialize an empty array of any type
  const [items, setItems] = useState<ParticipantStudyDetails[]>([]);


  const dispatch: AppDispatch = useDispatch();

  const tempRangeAnomalyDataUpdates = useSelector((state : RootState) => state.tempRangeAnomalyDataDetail);

  const [plotWidth, setPlotWidth] = useState(window.innerWidth - 262);

  const [currentTimeline, setCurrentTimeline] = useState<string>('1 Week');

  const [noData, setNoData] = useState(false);

  const { sharedState, setSharedState } = useSharedState();

  const [reloadCounter, setReloadCounter] = useState<boolean>(false);

  const [selectedDateRange, setSelectedDateRange] = useState<DateRange | undefined>({
    from: undefined,
    to: undefined,
  });

  const [selectedTimezoneString, setSelectedTimezoneString] = useState<string>("");

  // Set default timezone to the browser's timezone
  useEffect(() => {
      const browserTimezone = moment.tz.guess(); // Get the browser's timezone
      setSelectedTimezoneString(browserTimezone);
  }, []);

  useEffect(() => {
    // Function to update the plot width dynamically
    const handleResize = () => {
      setPlotWidth(window.innerWidth - 275);
    };

    // Set up the event listener for window resize
    window.addEventListener('resize', handleResize);

    // Clean up the event listener on component unmount
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  useEffect(() => {
    AnomalyDataStore = tempRangeAnomalyDataUpdates['anomalyData']
  }, [tempRangeAnomalyDataUpdates])

  useEffect(() => {
    dispatch(fetchtempRangeAnomalyDataDetails());
  }, [dispatch]);


  useEffect(() => {
    setItems(AnomalyDataStore)
  }, [searchQuery, tempRangeAnomalyDataUpdates] )

  const storeStudy = useSelector((state: RootState) => state.studyInfo);
  const storeStudyID = useSelector((state: RootState) => state.studyMapping);

  useEffect(() => {
    if(items.length > 0){
      // setLoading(false)
    }
  }, [items.length])

  const reloadData = async () => {

    setReloadCounter(!reloadCounter);

  };

  const [plotData, setPlotData] = useState<any>(null);
  const [studyName, setStudyName] = useState<string>("");
  const [noDataParticipants, setNoDataParticipants] = useState<string[][]>([]);

  // ---------------------------------------------------------------------------------------------------------------------------
  // Below state keeps track whether the component and its being data being loaded by DynamicURL

  const [participantDetailURLRedirect, setparticipantDetailURLRedirect] = useState<boolean>(false);
  const [selectedStudyIdFromDynamicURL, setSelectedStudyIdFromDynamicURL] = useState<string | null>(null);
  const [requestedParticipantFromDynamicURL, setRequestedParticipantFromDynamicURL] = useState<{ participant_euid: string; participant_name: string }>({
    participant_euid: "",
    participant_name: "",
  });

  const [requestedDateRangeFromDynamicURL, setRequestedDateRangeFromDynamicURL] = useState<DateRange | undefined>({
        from: undefined,
        to: undefined,
  });

  // ---------------------------------------------------------------------------------------------------------------------------
  // The below useEffect() hook listens to the global redux store for changes in studies and organizations and open the studyselectionpopup if All studies or organization is selected
  // Hook to check if All studies or study-organization is selected - and only to show studyselectionpopup only then

  useEffect(()=> {

    if (storeStudy && !participantDetailURLRedirect) {

      let StudyOrg = storeStudy.study.StudyOrg
      let StudyName = storeStudy.study.StudyName

      if(StudyOrg == "All Studies"){
        setModalVisible(true);
      }else if(StudyName == ""){
        setModalVisible(true);
      }else {
        setModalVisible(false);
      }

      // !!!!!!!!!!!!!!!!!!!!! Add condition to handle error studies

    }

  }, [storeStudy])

  // Function to calculate relative datetime
  function getRelativeDate(date: Date, adjustment: { days?: number; months?: number; years?: number }): Date {
    const newDate = new Date(date); // Create a copy of the date object

    if (adjustment.days) {
    newDate.setUTCDate(newDate.getUTCDate() + adjustment.days);
    }
    if (adjustment.months) {
    newDate.setUTCMonth(newDate.getUTCMonth() + adjustment.months);
    }
    if (adjustment.years) {
    newDate.setUTCFullYear(newDate.getUTCFullYear() + adjustment.years);
    }

    return newDate;
  
  }

  useEffect(() => {

    const now = new Date();

    const currentDate = new Date(Date.UTC(
        now.getUTCFullYear(),
        now.getUTCMonth(),
        now.getUTCDate(),
        now.getUTCHours(),
        now.getUTCMinutes(),
        now.getUTCSeconds(),
        now.getUTCMilliseconds()
    ));

    if(currentTimeline == "Today"){
      
      setSelectedDateRange({
        from: getRelativeDate(currentDate, { days: -1 }),
        to: currentDate,
      })

    }else if(currentTimeline == "1 Week"){

      setSelectedDateRange({
        from: getRelativeDate(currentDate, { days: -7 }),
        to: currentDate,
      })

    }else if(currentTimeline == "1 Month"){

      setSelectedDateRange({
        from: getRelativeDate(currentDate, { months: -1 }),
        to: currentDate,
      })

    }
    // else if(currentTimeline == "All Time"){
    //   timePeriod = 1000;
    // }


  }, [currentTimeline])


  // -----------------------------------------------------------------------------------------------------------------------------

  const [searchParams] = useSearchParams();
  const location = useLocation();
  const navigate = useNavigate();
  const paramValue = searchParams.get("intent");

  // Strategy how to handle this
  // 1. [Done] The select studies menu will not be opened incase URL Param strings are present
  // 2. [Done] The Dashboard will continue to load the studies from backend (for future use)
  // 3. [Done] A request for decrypting the encrypted query strings will be made
  // - Cleanup query string parameters when it is consumed the first time...
  // 4. Response containing the study ID will be used to set the current study in the dashboard and setting the current study state 
  // 5. This will load up the main dashboard data
  // 6. Later Participant Details will sent with this data to be shown (You need to modify participant details to work properly)

  // -- The above needs to be implemented without modifying any existing code... and should work with non encrypted query string parameters also

  
  // [Done] Verify which study is loaded in the above case? (All studies is loaded - need to change with respect to decrypted data)

  // [Done] Ensure that studies are loaded still --- This is loaded automatically irrespective of anything... done
  // [Done] Use the same technique useEffect used in selectstudiesmodal to update current dashboard to the current study (if both StudyData is loaded and Decrypted String is loaded)

  // 1. [Done] Create a query parameter string now
  // 2. Integrate all functionality from frontend
  // 3. Go to cloud and integrate encryption there.. that's it..

  // After you complete the functionality make this part component into a module file .ts file


  // TODO: 
  // Also verify whether all URL's are redirected to SPA

  // Also need to disable selectstudies dropdown when its loading

  // Implement this for dashboardmobile
  // Make the cloud part a module
  




  useEffect(() => {

    const paramValue = searchParams.get("intent");
    if(paramValue == "ParticipantDetailURLRedirect"){

      // Hide Select Studies menu
      setModalVisible(false);
      setparticipantDetailURLRedirect(true); // This will not make selectstudies modal visible when the studie data are loaded 
      
      const fetchDecryptedParams = async () => {

        console.log("Fetching Decrypted Parameter Strings")

        try {
          const response = await axios.get(
            `${BASE_URL}/getDecryptedParticipantData/?data=${searchParams.get("data")}`,
          );

          if (response.data['statusCode'] === 200) { 
            console.log("UNTOUCHED Decrypted DATA", response.data['body']);

            // 1. Manage Study selection here globally

            // Store it a state 
            // If all the states matches 1. Decrypted Data Loaded  2. Studies loaded in global state 3. If study present in studies.
            setSelectedStudyIdFromDynamicURL(response.data['body']['study'])
            setRequestedParticipantFromDynamicURL({participant_euid : response.data['body']['participant_euid'], participant_name : response.data['body']['participant_name']})

            setRequestedDateRangeFromDynamicURL({from : response.data['body']['timerange_from'], to: response.data['body']['timerange_to']})

            // 2. Load Main Dashboard Data based on this study and 
            /// Load Participant Data into an intermediate state value


            // Edge case to be solved (Later) : How to manage user permissioning here. (User Based Access Control)
            // [Done] How to handle edge case if any particular study is not present? - make shift solution for now -- show select studies modal incase study_id wrong
            // [Done] For this to work - we need decrypted value as well as studies in global state (handled this by using another useEffect)

            

          } else if(response.data['statusCode'] === 204){
            console.log("UNTOUCHED DATA", JSON.parse(response.data['body']));
          } else {
            console.log("UNTOUCHED ERROR", response);
            throw new Error('Failed to fetch data');
          }

        } catch (err: unknown) {
          if (axios.isAxiosError(err)) {
            // The error is an Axios error
            if (err.response) {
              // Server responded with a status other than 2xx
              console.error('Error response:', err.response);
              console.error('Status code:', err.response.status);
              console.error('Error data:', err.response.data);
            } else if (err.request) {
              // Request was made but no response was received
              console.error('No response received:', err.request);
            } else {
              // Something else happened during setup
              console.error('Error', err.message);
            }
          } else {
            // The error is not an Axios error
            console.error('Unknown error:', err);
          }
        } finally {

        }

      };

      fetchDecryptedParams();
      // seturlBasedRouting(false); // Do this when you have loaded all component logic


    }else{
      // show Select Studies menu incase no 
      setModalVisible(true);
    }



  }, [])

  let storeStudyMap = useSelector((state: RootState) => state.studyMapping);

  useEffect(() => {

      // Case 1. First Decrypted Value is loaded -> Studies is loaded
      // Case 2. Studies is Loaded -> Next Decrypted Value is Loaded

      // Check both conditions and then set study and organization and also urlBasedRouting is true and then deactivate urlBasedRouting 

      if(Object.keys(storeStudyMap.studyMapping).length !== 0 && selectedStudyIdFromDynamicURL && participantDetailURLRedirect){

        // Now write the logic here to manipulate the study in the global state

        let newStudy : StudyInfo = {
          StudyOrg: "",
          StudyName: ""
        };

        const checkStudyIDinStudyMap = () => {

          let checkResult = false;

          Object.entries(storeStudyMap.studyMapping).forEach(([studyName, details]) => {
            // const { organization_name, study_id } = details;
            // console.log(studyName)
            if(studyName == selectedStudyIdFromDynamicURL){
              checkResult = true;
            }

          });

          return checkResult;
        }

        if(checkStudyIDinStudyMap()){

          newStudy = {
            StudyOrg: storeStudyMap.studyMapping[selectedStudyIdFromDynamicURL]?.organization_name,
            StudyName: selectedStudyIdFromDynamicURL
          }
        
          dispatch(updateStudyInfo(newStudy));

          // !!!!!!!! Here only you will call the participantDetailModal and initialize the data for it

          
          setCurrentParticipantInFocus({'participant_name': requestedParticipantFromDynamicURL?.participant_name, 'participant_euid' : requestedParticipantFromDynamicURL?.participant_euid})



          setIsParticipantDetailModalVisible(true);



          // TODO: 
          // 1. [Done] Call ParticipantDetailModal from here using a intermediate statevariable (basic functionality) (Intermediate State since we dont buggy code to store)
          // 2. Add CustomTime Range support in ParticipantDetailsModal
          // 3. [Spot Testing Done]Do a ton of testing
          // 4. [Done]Implement this for dashboardmobile
          // 5. [Not Required]Also need to disable selectstudies dropdown when its loading
          // 5.5 [Done] Also need to change loading screen for DynamicURL
          // 6. Push all changes to the cloud (Backend and Frontend)
          // 7. Also verify whether all URL's are redirected to SPA
          // 8. Make the cloud part a module

          




        }else{

          // This runs when buggy code is received - ask dashboard user to select a study
          // Make Modal Visible
          setModalVisible(true);


        }
        
        // In both case set participantDetailURLRedirect to false
        // And then clear the query string parameters
        setparticipantDetailURLRedirect(false);

        // Remove query parameters from the URL (So that when the dashboard is switched back it doesnot load the same participant)
        // The below happens without refreshing the page 
        navigate(location.pathname, { replace: true });

      }


  }, [storeStudyMap, selectedStudyIdFromDynamicURL])



  // -----------------------------------------------------------------------------------------------------------------------------
  // Notes:
  // 1. Use CurrentTimeline to listen to time changes in the SelectStudiesModal and change to appropriate timerange (Done)
  // 2. Based on this change in timerange refactor the below timeline. (Done)
  // 3. Need to remove dependency on currentTimeline in the Loading Status logs from currentTimeline to TimeRange based status logs (Should i send other information from TimeSelectionButtonBar?)
  // 4. !!!!!! Need to propogate Time selection in SelectStudiesModal to TimeSelectionButtonBarComponent
  // 5. !!!!!! Need to develop standards for DateTime Objects across the entire dashboard.
  // 6. !!!!!! Fix API in backend so that if no active data is found, atleast send list of participants in the response.

  // ----------------------------------------------------------------------------------------------------------------------------
  // This is the main API using useEffect() functionality to listen to changes in the studies and currentTimeline and ask data from the Backend
  // TODO: Refactor this completely to get data based on timerange.

  useEffect(() => {
    
    if(Object.keys(storeStudyMap.studyMapping).length !== 0 && storeStudy.study.StudyName && selectedDateRange?.from != undefined && selectedDateRange?.to != undefined){

      // const timerangeFrom = Math.floor(selectedDateRange?.from.getTime() / 1000);
      // const timerangeTo = Math.floor(selectedDateRange?.to.getTime() / 1000);

      console.log("Fetching data w.r.to custom study and timerange", storeStudy.study.StudyName, "- From:" , selectedDateRange?.from.toISOString(), " To:", selectedDateRange?.to.toISOString())
      
      // console.log("Store Study ID: ", storeStudyID.studyMapping[storeStudy.study.StudyName].study_id)

      setLoading(true);

      const fetchData = async () => {
        setLoading(true);
        setNoData(false);
        setSharedState(true)
        setRefereshing(true);

        console.log('Study Name Sent:', storeStudy.study.StudyName, "-");

        try {
          const response = await axios.get(
            `${BASE_URL}/barChartBasedDataWithShockDataOPT/?study_name=${storeStudy.study.StudyName}&timezone_string=${selectedTimezoneString}&timerange_from=${selectedDateRange?.from?.toISOString()}&timerange_to=${selectedDateRange?.to?.toISOString()}&study_id=${storeStudyID.studyMapping[storeStudy.study.StudyName].study_id}`,
          );
      
          if (response.data['statusCode'] === 200) {  
            console.log("UNTOUCHED DATA", JSON.parse(response.data['body']));
            console.log("THE DATA IS HERE", JSON.parse(response.data['body'])['participant_data']);
            setPlotData(JSON.parse(response.data['body'])['participant_data']);
            setStudyName(JSON.parse(response.data['body'])['study_name']);
            setNoDataParticipants(JSON.parse(response.data['body'])['participant_euid_pairs_with_no_data'])
            console.log("THE PLOT DATA IS HERE");
            console.log(JSON.parse(response.data['body']));
          } else if(response.data['statusCode'] === 204){
            setStudyName(storeStudy.study.StudyName);
            setNoData(true);
          } else {
            console.log("UNTOUCHED ERROR", response);
            throw new Error('Failed to fetch data');
          }
        } catch (err: unknown) {
          if (axios.isAxiosError(err)) {
            // The error is an Axios error
            if (err.response) {
              // Server responded with a status other than 2xx
              console.error('Error response:', err.response);
              console.error('Status code:', err.response.status);
              console.error('Error data:', err.response.data);
            } else if (err.request) {
              // Request was made but no response was received
              console.error('No response received:', err.request);
            } else {
              // Something else happened during setup
              console.error('Error', err.message);
            }
          } else {
            // The error is not an Axios error
            console.error('Unknown error:', err);
          }
        } finally {
          setLoading(false);
          setSharedState(false);
          setRefreshDate(getCurrentDate());
          setRefereshing(false);
        }
      };
      
      fetchData();
    }

  }, [selectedDateRange, storeStudy, reloadCounter]);


  // ------------------------------------------------------------------------------------------------------------------------
  // The below is the callback function that will handle opening and closing of participant details modal.
  // TODO: 1. Need to send EUID also to ParticipantDetailsModal as part of the performance optimization steps -- DONE

  const showParticipantDetailsModal = ({ participant_name, participant_euid }: ParticipantModalDetails) => {
    setCurrentParticipantInFocus({ participant_name, participant_euid });
    setIsParticipantDetailModalVisible(true);
  };

  // ------------------------------------------------------------------------------------------------------------------------
  // The below is the callback function that will handle passing timeline(TimeRange) data from SelectStudiesModal to this Dashboard 
  // Callback function to handle data from the child
  const handleTimelineFromModal = (timeperiod: string) => {
    setCurrentTimeline(timeperiod);
  };

  // --------------------------------------------------------------------------------------------------------------------------------------------
  // ----- This is the callback function that will be sent to the TimeSelectionButtonBar component ------
  // ----- that will set the time range in this dashboard page ---------------

  const handleTimeRangeSelection = (data: DateRange, timezoneString: string) => {
    console.log('DateTime Range received from CustomTimeSelectionButtonBar:', data); // Log for debugging
    // -- Now after you get the correct time here -- manage it effectively to call the api to fetch the dashboard or relevant data.
    setSelectedDateRange(data); 
    setSelectedTimezoneString(timezoneString);
    // 1. Now store this timezoneString in a state - with a useEffect default value of current browser's timezone
    // 2. And pass this timezoneString with every API Call. 
    // 3. This needs to be done in both the dashboard and dashboardParticipantDetailsModal Page..
    // Technical Error Indicator
    // Granular level of reading of anomaly data
    // Labeling tool - in the plots itself

    // 4. In the back end its just a matter of converting all the API's
    // Next send text to Sam about the loss of real estate in participant details modal

    // After timezone integration -> Next work on the dashboard details page - add all the labels, and dynamic time selection 
    // - complete - and then deployment and code quality standards discussion.. 
    // Focus on completing the POC. - as many features as possible..

  };

  // ---------------------------------------------------------------------------------------------------------------------------------------------

  // useEffect(() => {
  //   console.log('Selected Date Range and Timezone')
  //   console.log(selectedDateRange);
  //   console.log(formatDateRange(selectedDateRange?.from));
  //   console.log(formatDateRange(selectedDateRange?.to));
  //   console.log(selectedTimezoneString);
  //   console.log(getUTCOffset(selectedTimezoneString))
  // }, [selectedDateRange, selectedTimezoneString])


  return (
    <>
      <div className="dashboard-page">
        <div className="content">

          <div className="tab-header">
            <div className="table-info-section">

              <div className="info-section-container">
                {isLoading ? (
                  <Skeleton></Skeleton>
                  ) : (
                  <>
                    <div className="study-name">
                      <span className="title title-large">Study</span> 
                      <span>&nbsp;</span>
                      <span className="title title-large">{studyName}</span>
                    </div>
                    <div className="participant-count">
                      <span className="label label-medium">{noData ? 0 : plotData.length + noDataParticipants.length}</span>
                      <span>&nbsp;</span>
                      <span className="label label-medium">Participants</span>
                    </div>
                  </>
                )}
              </div>
            </div>

            <div className="quick-actions">
              
                <div className="quick-actions-buttons">
                  <div className={`body-small refresh-date ${isRefreshing ? "" : ""}`}>
                    <span className="refresh-text">{isRefreshing ? "Refreshing..." : `Updated on `}</span>
                    <span className="refresh-date-text">{isRefreshing ? "" : refreshDate}</span>
                  </div>               
                  <MasterButton
                    options={{
                      layoutType: ButtonLayoutType.Icon,
                      label: "Refresh",
                      variation: ButtonVariation.Clean,
                      icon: refreshIcon,
                      size: ButtonSize.Medium,
                    }}
                    onClick={() => {
                      console.log("master button refresh");
                      reloadData()
                      // loadData(selectedStudy); // !!!!!!!!!!!!! Need to use the studyInfo state here to get the relevant study and load the data through the API
                    }}
                    disabled={isLoading}
                  ></MasterButton>

                  {/* <InputfieldWithPlaceholder
                    collapsable={true}
                    leftIcon={<SearchIcon fill={getComputedStyle(document.documentElement).getPropertyValue("--on-surface-variant")}></SearchIcon>}
                    rightActionIcon={<ClearIcon fill={getComputedStyle(document.documentElement).getPropertyValue("--on-surface-variant")} />}
                    onRightActionClicked={() => {
                      setSearchQuery("");
                      search("");
                      setSearchActive(false);
                    }}
                    value={searchQuery}
                    onValueChanged={(value) => {
                      if (value !== "") {
                        setSearchActive(true);
                      } else {
                        setSearchActive(false);
                      }
                      setSearchQuery(value);
                      search(value);
                    }}
                    type={searchActive && items.length === 0 ? InputfieldType.Error : InputfieldType.Normal}
                    placeholderValue={placeholderValue}
                  ></InputfieldWithPlaceholder> */}
              
                  {/* <ButtonGroup buttons={buttons} groupClassName="custom-button-group" /> */}

                  <CustomTimeSelectionButtonBar onSelect={handleTimeRangeSelection} modalSize={{ height: `calc(100vh - 250px)` }} parentID="dashboard-time-selector-button-bar" />


                  {/* <MasterButton
                    options={{
                      layoutType: ButtonLayoutType.Icon,
                      label: "Filter & Sorting",
                      variation: ButtonVariation.Outlined,
                      icon: filterIcon,
                      size: ButtonSize.Medium,
                    }}
                    onClick={() => {
                      console.log("Filter & Sorting button refresh");
                      // loadData(selectedStudy); // !!!!!!!!!!!!! Need to use the studyInfo state here to get the relevant study and load the data through the API
                    }}
                    disabled={isLoading}
                  ></MasterButton> */}
                </div>
                <div className="time-range-indicator">
                  <div className={`body-small time-range-block`}>
                    <span className="time-range">{`${formatDateRange(selectedDateRange?.from)} - ${formatDateRange(selectedDateRange?.to)}`}</span>
                    <span className="time-zone-text">{`${selectedTimezoneString} (${getUTCOffset(selectedTimezoneString)})`}</span>
                  </div> 
                </div>
            </div>
            
          </div>
          
          <div className="separator"></div>

          <div className="tick-labels-container">

            {!isLoading && plotData && plotData.length > 0 && (
              <div className="common-tick-labels">
                <div className="participant-detail-width">
                  <span className="label-medium label participant-detail-width-label">Participant ID</span>
                </div>
                <div className="tick-labels-area no-cursor">
                  
                  <Plot
                    data={
                      JSON.parse(plotData[0].chart_data).data.map((trace : Trace) => ({
                        ...trace,
                        opacity: 0, // Make the trace invisible by setting opacity to 0
                      }))
                    } 
                    layout={{
                      width: plotWidth,
                      height: 50,            // Adjust height for the X-axis component
                      xaxis: {
                        ...JSON.parse(plotData[0].chart_data).layout.xaxis,
                        // tickvals: JSON.parse(plotData[0].chart_data).layout.xaxis.tickvals,  // Use the tick values from one of the plots
                        // ticktext: JSON.parse(plotData[0].chart_data).layout.xaxis.ticktext,  // Use the tick labels from one of the plots
                        // showticklabels: true,  // Show the tick labels for the common X-axis
                        // ticks: "outside",      // Customize the tick style
                        tickformat: "%m/%d/%Y", // "%d/%m/%Y \n %H:%M",
                        tickmode: 'auto',
                        dragmode: false,
                        hovermode: false,
                        side: 'top',
                        tickfont: {
                          family: 'Lexend',
                          size: 12,                     // Customize font size
                          color: '#60598f',                // Customize font color
                        },
                      },
                      yaxis: { visible: false },  // Hide Y-axis
                      margin: {
                        t: 40, b: 0, l: 0, r: 0,  // Adjust margins to fit the axis
                      },
                      dragmode: false,
                      hovermode: false,
                    }}
                    config={{
                      displayModeBar: false, // Disable the mode bar completely
                      doubleClick: false
                    }}
                    style={{
                      cursor: 'none',  // Set a static cursor
                    }}
                    className="custom-top-border"
                  />
                </div>
              </div>
            )}

          </div>

          

          <div className="chart-area" ref={chartAreaRef}>
            <div className="chart-content hide-scrollbar" style={{ gap: "0px" }}>

              {/* {items.map((x, i) => (
                <div style={{ width: "100px", height: "100px" }}>
                  <ParticipantState
                    key={i}
                    index={i}
                    ParticipantStudyData={x}
                    onItemClicked={(index) => {
                      setSelectedParticipant(index);
                      setModalVisible(true);
                    }}
                  ></ParticipantState>
                </div>
              ))} */}

              {/* {plotData.length > 0 && (
                <div className="participant-chart-data">
                  <div className="participant-detail">
                    <span className="title title-small"></span>
                  </div>
                  <div className="participant-chart">
                    <Plot
                      data={JSON.parse(plotData[0].chart_data).data} 
                      layout={{
                        showlegend: true,     // Display the legend
                        legend: { orientation: "h" },  // Optional: Horizontal legend layout
                        width: 1100,
                        height: 80,
                        xaxis: { visible: false },  // Hide axes in the legend-only plot
                        yaxis: { visible: false },
                      }}
                    />
                  </div>
                </div>
              )} */}

              {isLoading ? (
                  <div className="loading-center-content">
                    {participantDetailURLRedirect ? (
                          <span className="title title-small">
                              Loading Participant Detail for the requested Participant ...
                          </span>
                      ) : (
                          <span className="title title-small">
                              Loading participant data for the {storeStudy.study.StudyName} study ...
                          </span>
                      )}
                  </div>
                ) : noData ? (

                  <div className="loading-center-content">
                    <span className="title title-small">There is no available data for the {storeStudy.study.StudyName} study in the selected time range.</span>
                  </div>

                ) : (

                  <>

                    <div style={{ height: '20px', width: '100%'}}></div>

                    {plotData && plotData.map((x: PlotData, i: number) => (
                      
                      <div className="participant-chart-data" key={i}>

                        <div className="participant-detail" onClick={() => showParticipantDetailsModal({'participant_name' : x.participant_name, 'participant_euid': x.euid})}>
                          <div className="inner-participant-detail">
                            <span className="title title-small">{x.participant_name}</span>
                            <DashboardParticipantInnerDetail
                              participant_name={x.participant_name}
                              cnt_indeterminate={x.cnt_indeterminate}
                              cnt_pos={x.cnt_pos}
                              last_updated_date={x.last_updated_date}
                              timeline={currentTimeline}
                            />
                          </div>
                          {/* <div className="hover-modal">
                            <DashboardParticipantHoverModal 
                              participant_name={x.participant_name}
                              cnt_indeterminate={x.cnt_indeterminate}
                              cnt_pos={x.cnt_pos}
                              last_updated_date={x.last_updated_date}
                              timeline={currentTimeline}
                            />
                          </div> */}
                        </div>
                        <div className="participant-chart" id={`plot-id-${i}`}>
                          <Plot
                            data={JSON.parse(x.chart_data).data}
                            layout={{...JSON.parse(x.chart_data).layout,
                              width: plotWidth,         // Modify the width of the plot
                              height: 100, 
                              showlegend: false, 
                              xaxis: {
                                ...JSON.parse(x.chart_data).layout.xaxis,
                                showticklabels: false,  // Show the tick labels for the common X-axis
                              },
                              dragmode: false, // 'none' will enable the drag mode - this is what we want to use inside the participant detail page
                              
                            }}
                            key={i} // Always include a key when rendering lists in React
                            config={{
                              displayModeBar: false, // Disable the mode bar completely
                              doubleClick: false,
                            }}
                            
                            className="no-cursor custom-border-allsides"
                          />
                        </div>
                      </div>
                    ))}

                    {noDataParticipants && noDataParticipants.map((x: string[], i: number) => (
                      <div className="participant-chart-data" key={plotData.length+i}>
                        <div className="participant-detail" onClick={() => showParticipantDetailsModal({'participant_name' : x[0], 'participant_euid': x[1]})}>
                          <div className="inner-participant-detail">
                            <span className="title title-small">{x[0]}</span>
                          </div>
                        </div>
                        <div className="participant-chart" id={`plot-id-${plotData.length+i}`}>
                          <div className="participant-chart-no-data" style={{ width: plotWidth + 'px', height: 100 + 'px' }}>
                            <span className="label label-medium">Participant has not synced in the selected time range.</span>
                          </div>
                        </div>
                      </div>
                    ))}

                    <div style={{ height: '200px', width: '100%'}}></div>

                  </>
                )}

            </div>
          </div>


        </div>

        {isParticipantDetailModalVisible && (
          <ModalOverlay
            closeModal={() => {
              setIsParticipantDetailModalVisible(false);
            }}
            className="dashboard-participant-details-modal"
          >
            <DashboardParticipantDetailsModal
              onCloseClicked={() => {
                setIsParticipantDetailModalVisible(false);
              }}
              participantName={currentParticipantInFocus?.participant_name}
              participantEUID={currentParticipantInFocus?.participant_euid}
              organizationName={storeStudy.study.StudyOrg}
              studyName={storeStudy.study.StudyName}
              customTimeRange={participantDetailURLRedirect ? requestedDateRangeFromDynamicURL : undefined}>
            </DashboardParticipantDetailsModal>
          </ModalOverlay>
        )}



        {isModalVisible && (
          <ModalOverlay
            closeModal={() => {
              // setModalVisible(false);
            }}
            className="dashboard-studies-selection-modal-mods"
          >
            <DashboardSelectStudiesModal
              onCloseClicked={() => {
                setModalVisible(false);
              }}
              onSendData={handleTimelineFromModal}
            ></DashboardSelectStudiesModal>
          </ModalOverlay>
        )}
        

      </div>
      
    </>
  );
};

export default Dashboard;
